import React, { forwardRef, useState, useEffect } from 'react';
import { motion } from 'motion/react';
export { AnimatePresence, MotionValue, motion, stagger, useAnimate, useAnimation, useCycle, useMotionValue, useScroll, useTransform, useViewportScroll } from 'motion/react';
import { faChevronLeft, faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ScaleLoader from 'react-spinners/ScaleLoader';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

var _excluded = ["onClick", "children", "motion", "style", "grow", "center", "row", "spaceBetween", "id", "alignCenter", "pad", "padL", "padR", "padT", "padB"];
var View = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$motion = _ref.motion,
    motion$1 = _ref$motion === void 0 ? false : _ref$motion,
    style = _ref.style,
    _ref$grow = _ref.grow,
    grow = _ref$grow === void 0 ? false : _ref$grow,
    _ref$center = _ref.center,
    center = _ref$center === void 0 ? false : _ref$center,
    _ref$row = _ref.row,
    row = _ref$row === void 0 ? false : _ref$row,
    _ref$spaceBetween = _ref.spaceBetween,
    spaceBetween = _ref$spaceBetween === void 0 ? false : _ref$spaceBetween,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$alignCenter = _ref.alignCenter,
    alignCenter = _ref$alignCenter === void 0 ? false : _ref$alignCenter,
    pad = _ref.pad,
    padL = _ref.padL,
    padR = _ref.padR,
    padT = _ref.padT,
    padB = _ref.padB,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var commonStyle = _extends({
    display: 'flex',
    alignItems: center || alignCenter ? 'center' : undefined,
    justifyContent: spaceBetween ? 'space-between' : center ? 'center' : 'flex-start',
    flexDirection: row ? 'row' : 'column',
    flexGrow: grow ? 1 : undefined
  }, onClick && {
    cursor: 'pointer'
  }, pad && {
    padding: pad
  }, padT && {
    paddingTop: padT
  }, padB && {
    paddingBottom: padB
  }, padR && {
    paddingRight: padR
  }, padL && {
    paddingLeft: padL
  }, style);
  if (motion$1) {
    return React.createElement(motion.div, Object.assign({}, id && {
      id: id
    }, rest, {
      ref: ref
    }, onClick && {
      onClick: onClick
    }, {
      style: commonStyle
    }), children);
  }
  return React.createElement("div", Object.assign({}, id && {
    id: id
  }, rest, {
    ref: ref
  }, onClick && {
    onClick: onClick
  }, {
    style: commonStyle
  }), children);
});

var Dot = function Dot(_ref) {
  var size = _ref.size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'black' : _ref$color,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return React.createElement(View, {
    style: _extends({
      width: size,
      height: size,
      borderRadius: size,
      backgroundColor: color
    }, style)
  });
};

var _excluded$1 = ["children", "style", "center", "bold", "italic", "block", "weight", "color", "size", "motion"];
var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$center = _ref.center,
    center = _ref$center === void 0 ? false : _ref$center,
    _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold,
    _ref$italic = _ref.italic,
    italic = _ref$italic === void 0 ? false : _ref$italic,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? true : _ref$block,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 300 : _ref$weight,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? null : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'inherit' : _ref$size,
    _ref$motion = _ref.motion,
    motion$1 = _ref$motion === void 0 ? false : _ref$motion,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var styleProps = _extends({
    textAlign: center ? 'center' : 'inherit',
    fontStyle: italic ? 'italic' : 'normal',
    fontSize: size,
    fontWeight: bold ? 'bold' : weight,
    lineHeight: 1.33,
    color: !!color ? color : 'inherit'
  }, style);
  if (block) {
    if (motion$1) return React.createElement(motion.div, Object.assign({
      ref: ref
    }, rest, {
      style: styleProps
    }), children);
    return React.createElement("div", Object.assign({
      ref: ref
    }, rest, {
      style: styleProps
    }), children);
  }
  if (motion$1) return React.createElement(motion.span, Object.assign({
    ref: ref
  }, rest, {
    style: styleProps
  }), children);
  return React.createElement("span", Object.assign({
    ref: ref
  }, rest, {
    style: styleProps
  }), children);
});

var Warning = function Warning(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return React.createElement(View, {
    style: _extends({
      textAlign: 'center',
      fontSize: 15,
      background: '#fff9e6',
      borderTop: '1px solid #ff9800',
      padding: 5,
      borderRadius: 2,
      color: '#414141',
      boxShadow: '0px 1px 3px #80808063'
    }, style)
  }, React.createElement(Text, {
    weight: 300
  }, children));
};
var Error = function Error(_ref2) {
  var children = _ref2.children,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style;
  return React.createElement(View, {
    style: _extends({
      textAlign: 'center',
      fontSize: 15,
      background: '#ffeeee',
      borderTop: '1px solid #ee0000',
      padding: 5,
      borderRadius: 2,
      color: '#414141',
      boxShadow: '0px 1px 3px #80808063'
    }, style)
  }, React.createElement(Text, null, children));
};

var AnimatedTextAreaInput = function AnimatedTextAreaInput(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    placeholder = _ref.placeholder,
    _ref$containerStyle = _ref.containerStyle,
    containerStyle = _ref$containerStyle === void 0 ? {} : _ref$containerStyle,
    _ref$inputStyle = _ref.inputStyle,
    inputStyle = _ref$inputStyle === void 0 ? {} : _ref$inputStyle,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 4 : _ref$rows;
  return React.createElement(View, {
    style: _extends({}, containerStyle, {
      position: 'relative',
      border: '1px solid lightgrey',
      borderRadius: 4,
      minHeight: 40,
      height: rows * 25
    })
  }, React.createElement(View, {
    style: {
      position: 'absolute',
      padding: 7,
      marginLeft: 7,
      transition: 'all 0.3s ease-in-out',
      color: 'rgba(0, 0, 0, 0.7)',
      fontSize: 18,
      zIndex: 5,
      lineHeight: 1.3,
      height: 100,
      opacity: value.length > 0 ? 0 : 1
    }
  }, placeholder), React.createElement("textarea", {
    rows: rows,
    style: _extends({
      background: 'rgba(0,0,0,0)',
      border: 'none',
      position: 'absolute',
      zIndex: 10,
      padding: '10px 10px 10px 15px',
      fontSize: 18,
      borderRadius: 4,
      color: 'black',
      width: '100%'
    }, inputStyle),
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    }
  }));
};

var _excluded$2 = ["value", "setValue", "placeholder", "type", "inputStyle", "containerStyle", "placeholderStyle", "disabled", "height", "inputWidth"];
var BORDER_WIDTH = 2;
var AnimatedTextInput = /*#__PURE__*/forwardRef(function AnimatedTextInput(_ref, ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? '' : _ref$type,
    _ref$inputStyle = _ref.inputStyle,
    inputStyle = _ref$inputStyle === void 0 ? {} : _ref$inputStyle,
    _ref$containerStyle = _ref.containerStyle,
    containerStyle = _ref$containerStyle === void 0 ? {} : _ref$containerStyle,
    _ref$placeholderStyle = _ref.placeholderStyle,
    placeholderStyle = _ref$placeholderStyle === void 0 ? {} : _ref$placeholderStyle,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 43 : _ref$height,
    _ref$inputWidth = _ref.inputWidth,
    inputWidth = _ref$inputWidth === void 0 ? null : _ref$inputWidth,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return React.createElement(View, {
    style: _extends({
      position: 'relative',
      height: height,
      border: BORDER_WIDTH / 2 + "px solid lightgrey",
      borderRadius: 4
    }, inputWidth && {
      width: inputWidth
    }, containerStyle)
  }, React.createElement(View, {
    style: _extends({
      position: 'absolute',
      padding: 9,
      marginLeft: 7,
      transition: 'all 0.3s ease-in-out',
      color: 'rgba(0, 0, 0, 0.7)',
      fontSize: 18,
      zIndex: 5,
      lineHeight: 1.3,
      height: height,
      opacity: value.length > 0 ? 0 : 1
    }, placeholderStyle)
  }, placeholder), React.createElement("input", Object.assign({
    ref: ref,
    style: _extends({
      background: 'transparent',
      border: 'none',
      position: 'absolute',
      zIndex: 10,
      height: height - 2,
      padding: '10px 10px 10px 15px',
      fontSize: 18,
      borderRadius: 4,
      color: 'black',
      width: '100%'
    }, inputWidth && {
      width: typeof inputWidth === 'number' ? inputWidth - BORDER_WIDTH : "calc(" + inputWidth + " - " + BORDER_WIDTH + "px)"
    }, inputStyle),
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    type: type ? type : 'text',
    disabled: disabled
  }, rest)));
});

var GreenButton = function GreenButton(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children,
    _ref$isEmoji = _ref.isEmoji,
    isEmoji = _ref$isEmoji === void 0 ? false : _ref$isEmoji,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'green' : _ref$color,
    _ref$yellow = _ref.yellow,
    yellow = _ref$yellow === void 0 ? false : _ref$yellow,
    _ref$grey = _ref.grey,
    grey = _ref$grey === void 0 ? false : _ref$grey,
    _ref$disabledClick = _ref.disabledClick,
    disabledClick = _ref$disabledClick === void 0 ? null : _ref$disabledClick,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? false : _ref$block;
  if (disabled || color === 'grey' || grey) {
    style = _extends({}, style, {
      backgroundColor: '#cdcdcd',
      background: '#cdcdcd',
      borderBottom: 0
    });
  }
  if (color === 'yellow' || yellow) {
    style = _extends({}, style, {
      backgroundColor: '#fce789',
      background: '#fce789',
      color: 'black'
    });
  }
  if (block) {
    style = _extends({}, style, {
      display: 'inline-block',
      paddingLeft: 18,
      paddingRight: 18
    });
  }
  var onClickPreventDisabled = function onClickPreventDisabled() {
    if (disabled && typeof disabledClick === 'function') disabledClick();
    if (disabled) return;
    onClick();
  };
  return React.createElement(View, {
    style: _extends({
      padding: '10px',
      fontSize: '17px',
      textAlign: 'center',
      margin: '0 auto',
      background: 'black',
      boxShadow: '0px 0px 12px -8px #252525',
      borderBottom: '1px solid #4b4b4b',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      borderRadius: '5px'
    }, style),
    onClick: onClickPreventDisabled
  }, isEmoji && React.createElement("span", {
    style: {
      width: 29,
      marginRight: 5
    }
  }, children), !isEmoji && children);
};

var _excluded$3 = ["children", "style"];
var Container = function Container(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return React.createElement(View, Object.assign({
    style: _extends({
      position: 'relative',
      fontSize: 18,
      minHeight: 40,
      verticalAlign: 'middle',
      marginBottom: 20,
      border: '1px solid lightgrey',
      background: 'white',
      borderRadius: 4
    }, style)
  }, rest), children);
};

var WhiteButton = function WhiteButton(_ref) {
  var _ref$red = _ref.red,
    red = _ref$red === void 0 ? false : _ref$red,
    _ref$grey = _ref.grey,
    grey = _ref$grey === void 0 ? false : _ref$grey,
    children = _ref.children,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$big = _ref.big,
    big = _ref$big === void 0 ? false : _ref$big;
  var clickMe = function clickMe() {
    if (disabled) return;
    onClick();
  };
  var newStyle = _extends({}, style, {
    opacity: disabled ? 0.3 : 1,
    padding: big ? '10px 15px' : null
  });
  if (red) {
    newStyle.borderColor = '#e73c0b';
    newStyle.color = '#e73c0b';
  }
  if (grey) {
    newStyle.borderColor = '#e9e9e9';
    newStyle.color = 'grey';
  }
  return React.createElement(View, {
    style: _extends({
      display: 'inline-block',
      paddingBlock: 3,
      paddingInline: 9,
      background: 'white',
      textAlign: 'center',
      borderRadius: 4,
      color: '#6caa32',
      border: '1px solid #6caa32',
      cursor: 'pointer'
    }, newStyle),
    onClick: clickMe
  }, React.createElement(Text, {
    size: 14
  }, children));
};

var FormContainer = function FormContainer(_ref) {
  var children = _ref.children,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 600 : _ref$maxWidth,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return React.createElement(View, {
    style: _extends({
      width: '100%',
      height: '100%',
      backgroundColor: '#fcfcfc',
      overflow: 'auto'
    }, style)
  }, React.createElement(View, {
    style: {
      maxWidth: maxWidth,
      width: '100%',
      margin: '0 auto',
      padding: 10
    }
  }, children));
};

var Back = function Back(_ref) {
  var _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return React.createElement(View, {
    onClick: onClick,
    style: _extends({
      width: 45,
      height: 48,
      cursor: 'pointer'
    }, style)
  }, React.createElement(FontAwesomeIcon, {
    icon: faChevronLeft,
    fontSize: 20,
    style: {
      paddingTop: 13,
      paddingLeft: 13,
      paddingBottom: 13,
      paddingRight: 13
    }
  }));
};

var CloseButton = function CloseButton(props) {
  return React.createElement(View, Object.assign({
    style: {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: 10,
      cursor: 'pointer'
    }
  }, props), React.createElement(FontAwesomeIcon, {
    icon: faClose,
    fontSize: 28
  }));
};

var _excluded$4 = ["children", "style"];
var Body = function Body(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  return React.createElement(View, Object.assign({
    style: _extends({
      fontSize: 14,
      textAlign: 'center',
      width: '100%',
      maxWidth: 360,
      margin: '0 auto 0 auto',
      lineHeight: 22,
      background: 'white',
      padding: 10
    }, style)
  }, rest), children);
};

var Free = function Free(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return React.createElement(View, {
    style: _extends({
      backgroundColor: 'black',
      color: 'white',
      padding: '1px 8px 1px 9px',
      display: 'inline-block',
      margin: '0px 4px',
      border: '1px solid #fce58fb5',
      transform: 'rotate(-4deg)',
      borderRadius: 2,
      fontWeight: 600
    }, style),
    exit: {
      scale: 0
    },
    initial: {
      scale: 0,
      rotate: -180
    },
    animate: {
      scale: 1,
      rotate: -3,
      transition: {
        delay: 0.5
      }
    }
  }, "free");
};

var Title = function Title(_ref) {
  var children = _ref.children;
  return React.createElement(Text, {
    center: true,
    size: 14,
    weight: 600,
    style: {
      padding: 5
    }
  }, children);
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    Link = _ref.Link;
  return React.createElement("div", null, React.createElement("style", null, "\n    .breadcrumb-container{\n      width:100%;\n      background:white;    \n    }\n    \n    .bcca-breadcrumb {\n      margin: 0 auto;\n      \n    }\n    \n    /*** breadcrumb container ***/\n    .bcca-breadcrumb {\n      display: flex;\n      flex-direction: row-reverse;\n      flex-shrink: 0;\n      width: 100%;\n      max-width: 600px;\n      margin-bottom: 15px;\n      position: relative;\n      justify-content: flex-end;\n    }\n    \n    /*** breadcrumb items ***/\n    .bcca-breadcrumb-item {\n      transition: all 0.2s ease-in-out;\n      height: 50px;\n      background: white;\n      box-shadow: 0px 0px 1px -2px #d9d9d9;\n      line-height: 50px;\n      padding-left: 50px;\n      padding-right: 25px;\n      font-size: 14px;\n      font-weight: 600;\n      color: rgba(74, 74, 74, 0.8);\n      position: relative;\n      float: left;\n    }\n    \n    .bcca-breadcrumb-item:after {\n      transition: all ease-in-out 0.2s;\n      content: \"\";\n      position: absolute;\n      left: calc(100% - 10px);\n      top: 7px;\n      z-index: 1;\n      width: 0;\n      height: 0;\n      border: 18px solid #ffffff;\n      border-left-color: transparent;\n      border-bottom-color: transparent;\n      box-shadow: 0px 0px 0 0px #d9d9d9, 5px -5px 10px -4px #d9d9d9;\n      transform: rotate(45deg);\n      margin-left: -9px;\n    }\n    \n    .bcca-breadcrumb-item:last-child {\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n      padding-left: 10px;\n      box-shadow: 0px 0px 0px 0px #d9d9d9;  \n    }\n    \n    .bcca-breadcrumb-item:first-child {\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n      color: #007f3b;\n      box-shadow: 0px 0px 0px 0px #d9d9d9;  \n    }\n    \n    .bcca-breadcrumb-item:first-child:after {\n      content: \"\";\n      display: none;\n    }\n    \n    .bcca-breadcrumb-item i {\n      margin-left: 5px;\n      color: rgba(0, 0, 0, 0.2);\n    }\n    \n    /*** hover breadcrumbs ***/\n    .bcca-breadcrumb-item:hover {\n      background-color: #f9f9f9;\n    }\n    \n    .bcca-breadcrumb-item:hover:after {\n      border: 18px solid #f9f9f9;\n      border-left-color: transparent;\n      border-bottom-color: transparent;\n    }\n    \n    .bcca-breadcrumb-item:first-child:hover {\n      background-color: unset;\n    }\n    a.bcca-breadcrumb-item{\n      text-decoration:none;\n    }\n    \n  "), React.createElement("div", {
    className: "breadcrumb-container"
  }, React.createElement("div", {
    className: "bcca-breadcrumb"
  }, breadcrumbs.reverse().map(function (b, i) {
    return i !== 0 ? React.createElement(Link, {
      href: b.link,
      legacyBehavior: true
    }, React.createElement("a", {
      className: "bcca-breadcrumb-item"
    }, b.name)) : React.createElement("div", {
      className: "bcca-breadcrumb-item"
    }, b.name);
  }))));
};

var PageContent = function PageContent(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return React.createElement(View, {
    style: _extends({
      maxWidth: 280,
      margin: '0 auto',
      paddingTop: 20,
      width: '100%'
    }, style)
  }, children);
};

var Spacer = function Spacer(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 75 : _ref$height;
  return React.createElement(View, {
    style: {
      width: '100%',
      height: height
    }
  });
};

var SHADOW_DOWN = "0px 8px 5px -8px rgba(0, 0, 0, 0.08)";
var SHADOW_UP = "0px -8px 5px -8px rgba(0, 0, 0, 0.08)";
var styleSheet = {
  absoluteFillObject: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  SHADOW_DOWN: SHADOW_DOWN,
  SHADOW_UP: SHADOW_UP
};

var animationData = {
  v: '4.8.0',
  meta: {
    g: 'LottieFiles AE 3.0.2',
    a: '',
    k: '',
    d: '',
    tc: ''
  },
  fr: 30,
  ip: 0,
  op: 80,
  w: 1080,
  h: 1080,
  nm: 'C',
  assets: [],
  layers: [{
    ind: 1,
    ty: 4,
    nm: 'L',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0.363],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 0,
          s: [0]
        }, {
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 10,
          s: [45]
        }, {
          i: {
            x: [0.376],
            y: [0.95]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 20,
          s: [45]
        }, {
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 30,
          s: [0]
        }, {
          i: {
            x: [0.376],
            y: [0.9]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 40,
          s: [0]
        }, {
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 50,
          s: [-45]
        }, {
          i: {
            x: [0.35],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 60,
          s: [-45]
        }, {
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 70,
          s: [0]
        }, {
          t: 80,
          s: [0]
        }]
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.363,
            y: 1
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 0,
          s: [313.167, 559, 0],
          to: [41.805, 0.167, 0],
          ti: [-41.805, -0.167, 0]
        }, {
          i: {
            x: 0.667,
            y: 0.667
          },
          o: {
            x: 0.333,
            y: 0.333
          },
          t: 10,
          s: [564, 560, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.376,
            y: 1
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 20,
          s: [564, 560, 0],
          to: [36.899, -0.167, 0],
          ti: [-36.899, 0.167, 0]
        }, {
          i: {
            x: 0.667,
            y: 0.667
          },
          o: {
            x: 0.333,
            y: 0.333
          },
          t: 30,
          s: [785.396, 559, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.376,
            y: 1
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 40,
          s: [785.396, 559, 0],
          to: [-44.566, 0.5, 0],
          ti: [44.566, -0.5, 0]
        }, {
          i: {
            x: 0.667,
            y: 0.667
          },
          o: {
            x: 0.333,
            y: 0.333
          },
          t: 50,
          s: [518, 562, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.35,
            y: 1
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 60,
          s: [518, 562, 0],
          to: [-34.139, -0.5, 0],
          ti: [34.139, 0.5, 0]
        }, {
          i: {
            x: 0.667,
            y: 0.667
          },
          o: {
            x: 0.333,
            y: 0.333
          },
          t: 70,
          s: [313.167, 559, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          t: 80,
          s: [313.167, 559, 0]
        }]
      },
      a: {
        a: 0,
        k: [0, 0, 0]
      },
      s: {
        a: 0,
        k: [100, 100, 100]
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ks: {
          a: 0,
          k: {
            i: [[42.262, 17.184], [0, -17.184], [0, 38.663], [0, 30.061], [14.735, 0], [0, -30.073], [0, -38.652], [0, 47.223], [0, 64.426], [0, -84.993], [-43.336, 0], [0, -90.196], [-35.859, 0], [0, 90.195], [0, 0], [0, 88.872]],
            o: [[0, 64.426], [0, 47.223], [0, -38.652], [0, -30.073], [-14.744, 0], [0, 30.061], [0, 38.663], [0, -17.184], [-42.254, 17.184], [0, 88.872], [0, 0], [0, 90.195], [35.858, 0], [0, -90.196], [43.336, 0], [0, -84.993]],
            v: [[76.482, -396.503], [76.482, -220.402], [23.224, -216.115], [23.224, -346.044], [0.004, -426.25], [-23.224, -346.044], [-23.224, -216.115], [-76.482, -220.402], [-76.482, -396.503], [-122.452, -171.249], [-29.521, -48.604], [-67.537, 301.705], [0.004, 426.25], [67.536, 301.705], [29.527, -48.604], [122.452, -171.249]],
            c: true
          }
        },
        nm: 'P'
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0, 0, 0, 1]
        },
        o: {
          a: 0,
          k: 100
        },
        r: 1,
        nm: 'F'
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0]
        },
        a: {
          a: 0,
          k: [0, 0]
        },
        s: {
          a: 0,
          k: [100, 100]
        },
        r: {
          a: 0,
          k: 0
        },
        o: {
          a: 0,
          k: 100
        },
        sk: {
          a: 0,
          k: 0
        },
        sa: {
          a: 0,
          k: 0
        },
        nm: 'T'
      }],
      nm: 'G'
    }],
    ip: 0,
    op: 80,
    st: 0
  }, {
    ind: 2,
    ty: 4,
    nm: 'L',
    parent: 1,
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100
      },
      r: {
        a: 0,
        k: 0
      },
      p: {
        a: 0,
        k: [0.069, -30.501, 0]
      },
      a: {
        a: 0,
        k: [0, 0, 0]
      },
      s: {
        a: 0,
        k: [111, 111, 100]
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ks: {
          a: 0,
          k: {
            i: [[-43.336, 0], [0, -90.196], [-35.859, 0], [0, 90.195], [0, 0]],
            o: [[0, 0], [0, 90.195], [35.858, 0], [0, -90.196], [43.336, 0]],
            v: [[-29.521, -48.604], [-67.537, 301.705], [0.004, 426.25], [67.536, 301.705], [29.527, -48.604]],
            c: true
          }
        },
        nm: 'P'
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 0, 0, 1]
        },
        o: {
          a: 0,
          k: 100
        },
        r: 1,
        nm: 'F'
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0]
        },
        a: {
          a: 0,
          k: [0, 0]
        },
        s: {
          a: 0,
          k: [100, 100]
        },
        r: {
          a: 0,
          k: 0
        },
        o: {
          a: 0,
          k: 100
        },
        sk: {
          a: 0,
          k: 0
        },
        sa: {
          a: 0,
          k: 0
        },
        nm: 'T'
      }],
      nm: 'G'
    }],
    ip: 0,
    op: 80,
    st: 0
  }, {
    ind: 3,
    ty: 4,
    nm: 'L',
    tt: 2,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0.363],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 0,
          s: [0]
        }, {
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 10,
          s: [-45]
        }, {
          i: {
            x: [0.376],
            y: [1.05]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 20,
          s: [-45]
        }, {
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 30,
          s: [0]
        }, {
          i: {
            x: [0.376],
            y: [1.1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 40,
          s: [0]
        }, {
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 50,
          s: [45]
        }, {
          i: {
            x: [0.35],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 60,
          s: [45]
        }, {
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 70,
          s: [0]
        }, {
          t: 80,
          s: [0]
        }]
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0.363,
            y: 1
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 0,
          s: [785.396, 559, 0],
          to: [-44.566, 0.5, 0],
          ti: [44.566, -0.5, 0]
        }, {
          i: {
            x: 0.667,
            y: 0.667
          },
          o: {
            x: 0.333,
            y: 0.333
          },
          t: 10,
          s: [518, 562, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.376,
            y: 1
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 20,
          s: [518, 562, 0],
          to: [-34.139, -0.5, 0],
          ti: [34.139, 0.5, 0]
        }, {
          i: {
            x: 0.667,
            y: 0.667
          },
          o: {
            x: 0.333,
            y: 0.333
          },
          t: 30,
          s: [313.167, 559, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.376,
            y: 1
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 40,
          s: [313.167, 559, 0],
          to: [41.805, 0.167, 0],
          ti: [-41.805, -0.167, 0]
        }, {
          i: {
            x: 0.667,
            y: 0.667
          },
          o: {
            x: 0.333,
            y: 0.333
          },
          t: 50,
          s: [564, 560, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.35,
            y: 1
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 60,
          s: [564, 560, 0],
          to: [36.899, -0.167, 0],
          ti: [-36.899, 0.167, 0]
        }, {
          i: {
            x: 0.667,
            y: 0.667
          },
          o: {
            x: 0.333,
            y: 0.333
          },
          t: 70,
          s: [785.396, 559, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          t: 80,
          s: [785.396, 559, 0]
        }]
      },
      a: {
        a: 0,
        k: [0, 0, 0]
      },
      s: {
        a: 0,
        k: [100, 100, 100]
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ks: {
          a: 0,
          k: {
            i: [[2.12, 158.409], [59.132, 0], [1.317, -98.688], [0, -39.576], [0, -90.196], [-35.851, 0], [0, 90.195], [0, 0]],
            o: [[-1.309, -98.688], [-59.131, 0], [-2.112, 158.409], [0, 0], [0, 90.195], [35.859, 0], [0, -90.196], [0, -39.576]],
            v: [[133.048, -234.994], [0.003, -426.25], [-133.048, -234.994], [-29.512, -48.604], [-67.536, 301.705], [0.003, 426.25], [67.544, 301.705], [29.528, -48.604]],
            c: true
          }
        },
        nm: 'P'
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0, 0, 0, 1]
        },
        o: {
          a: 0,
          k: 100
        },
        r: 1,
        nm: 'F'
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0]
        },
        a: {
          a: 0,
          k: [0, 0]
        },
        s: {
          a: 0,
          k: [100, 100]
        },
        r: {
          a: 0,
          k: 0
        },
        o: {
          a: 0,
          k: 100
        },
        sk: {
          a: 0,
          k: 0
        },
        sa: {
          a: 0,
          k: 0
        },
        nm: 'T'
      }],
      nm: 'G'
    }],
    ip: 0,
    op: 80,
    st: 0
  }],
  markers: []
};
var LoadingAnimationCutlery = function LoadingAnimationCutlery(_ref) {
  var _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 60 : _ref$iconSize;
  var _useState = useState(null),
    Lottie = _useState[0],
    setLottiePlayer = _useState[1];
  useEffect(function () {
    import('react-lottie').then(function (module) {
      setLottiePlayer(function () {
        return module["default"];
      });
    });
  }, []);
  return !!Lottie ? React.createElement(Lottie, {
    width: iconSize,
    height: iconSize,
    options: {
      loop: true,
      animationData: animationData,
      autoplay: true,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    }
  }) : React.createElement(View, {
    style: {
      width: iconSize,
      height: iconSize
    }
  });
};

var LoadingAnimation = function LoadingAnimation(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#000000' : _ref$color;
  return React.createElement(ScaleLoader, Object.assign({}, style, {
    color: color,
    loading: true
  }));
};
var Loading = function Loading(_ref2) {
  var _ref2$iconSize = _ref2.iconSize,
    iconSize = _ref2$iconSize === void 0 ? 60 : _ref2$iconSize;
  return React.createElement(View, {
    center: true,
    style: _extends({}, styleSheet.absoluteFillObject, {
      background: 'white'
    })
  }, React.createElement(LoadingAnimationCutlery, {
    iconSize: iconSize
  }));
};

var Modal = function Modal(_ref) {
  var children = _ref.children,
    _ref$close = _ref.close,
    close = _ref$close === void 0 ? function () {} : _ref$close;
  return React.createElement(View, {
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 100
    },
    onClick: close,
    key: 'modal',
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, children);
};

var Subtitle = function Subtitle(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return React.createElement(Text, {
    center: true,
    size: 16,
    style: _extends({
      display: 'block',
      margin: '0px auto 23px auto',
      lineHeight: 1.16667
    }, style)
  }, children);
};

var styles = {
  dotsContainer: {
    top: 0,
    left: 0,
    right: 0,
    position: 'absolute',
    backgroundColor: 'white',
    padding: 21,
    width: 240,
    justifyContent: 'center',
    flexDirection: 'row',
    zIndex: 0,
    display: 'flex',
    height: 55
  },
  container: {
    width: 220,
    height: 55,
    display: 'flex'
  },
  textInput: {
    background: 'transparent',
    width: 240,
    padding: 15,
    height: 55,
    textAlign: 'left',
    paddingLeft: 68,
    fontSize: 20,
    letterSpacing: 3,
    position: 'absolute',
    border: '1px solid lightgrey',
    borderRadius: 3,
    fontFamily: 'Gotham',
    top: 0
  },
  dot: {
    borderRadius: 10,
    width: 10,
    height: 10,
    paddingLeft: 5,
    paddingRight: 5,
    marginTop: 2,
    position: 'relative',
    left: -5
  }
};
var Dot$1 = function Dot(_ref) {
  var _ref$opacity = _ref.opacity,
    opacity = _ref$opacity === void 0 ? 1 : _ref$opacity,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? true : _ref$marginRight;
  return React.createElement("div", {
    style: _extends({}, styles.dot, {
      marginRight: marginRight ? 5 : 0,
      opacity: opacity === 1 ? 0.2 : 0,
      backgroundColor: 'black'
    })
  });
};
var NumericCodeInput = function NumericCodeInput(_ref2) {
  var setExternalValue = _ref2.onChange,
    onPresEnterKey = _ref2.onPresEnterKey;
  var _useState = useState(''),
    value = _useState[0],
    setValue = _useState[1];
  var numberOfDigitsEntered = value.length;
  useEffect(function () {
    setExternalValue(value);
  }, [value]);
  return React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React.createElement("div", {
    style: styles.container
  }, React.createElement("div", {
    style: styles.dotsContainer
  }, React.createElement(Dot$1, {
    opacity: numberOfDigitsEntered > 0 ? 0 : 1
  }), React.createElement(Dot$1, {
    opacity: numberOfDigitsEntered > 1 ? 0 : 1
  }), React.createElement(Dot$1, {
    opacity: numberOfDigitsEntered > 2 ? 0 : 1
  }), React.createElement(Dot$1, {
    opacity: numberOfDigitsEntered > 3 ? 0 : 1
  }), React.createElement(Dot$1, {
    opacity: numberOfDigitsEntered > 4 ? 0 : 1
  }), React.createElement(Dot$1, {
    opacity: numberOfDigitsEntered > 5 ? 0 : 1,
    marginRight: false
  }))), React.createElement("input", {
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter' && onPresEnterKey) onPresEnterKey();
    },
    type: "text",
    name: "token",
    id: "token",
    inputMode: "numeric",
    pattern: "[0-9]*",
    autoComplete: "one-time-code",
    style: styles.textInput,
    value: value,
    onChange: function onChange(event) {
      var text = event.target.value;
      if (text.length < 7 && (!isNaN(parseInt(text)) || text === '')) setValue(text);
    },
    autoFocus: true
  }));
};

var _excluded$5 = ["id", "paddingTop", "bottomMargin", "paddingBottom", "height", "absolute", "children", "onScroll", "style"];
var ScrollView = function ScrollView(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'scroll-view' : _ref$id,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? 0 : _ref$paddingTop,
    _ref$paddingBottom = _ref.paddingBottom,
    paddingBottom = _ref$paddingBottom === void 0 ? 0 : _ref$paddingBottom,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'auto' : _ref$height,
    _ref$absolute = _ref.absolute,
    absolute = _ref$absolute === void 0 ? true : _ref$absolute,
    children = _ref.children,
    _ref$onScroll = _ref.onScroll,
    onScroll = _ref$onScroll === void 0 ? null : _ref$onScroll,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  return React.createElement("div", Object.assign({
    id: id,
    style: _extends({
      width: '100%',
      padding: 0,
      margin: 0,
      height: absolute ? height : 'auto',
      maxHeight: height,
      overflowY: 'scroll',
      overflowX: 'hidden'
    }, style, {
      paddingTop: paddingTop,
      paddingBottom: paddingBottom
    }),
    onScroll: onScroll
  }, rest), children);
};

var _excluded$6 = ["children", "style", "bold", "weight", "size"];
var I = function I(_ref) {
  var children = _ref.children,
    style = _ref.style,
    _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'inherit' : _ref$weight,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'inherit' : _ref$size,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  return React.createElement("span", Object.assign({}, rest, {
    style: _extends({
      fontStyle: 'italic',
      fontSize: size,
      fontWeight: bold ? 'bold' : weight
    }, style)
  }), children);
};

var _excluded$7 = ["children", "color", "style", "italic", "weight", "size"];
var B = function B(_ref) {
  var children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'inherit' : _ref$color,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$italic = _ref.italic,
    italic = _ref$italic === void 0 ? false : _ref$italic,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 700 : _ref$weight,
    size = _ref.size,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  return React.createElement("span", Object.assign({}, rest, {
    style: _extends({
      fontStyle: italic ? 'italic' : 'normal',
      fontSize: !!size ? size : 'inherit',
      fontWeight: weight,
      color: color
    }, style)
  }), children);
};

var HANDEL_WIDTH = 27;
var TRACK_PADDING = 4;
var SWITCH_TRACK_COLOR = '#EDEDED';
var calcSwitchPosition = function calcSwitchPosition(width, handleWidth, trackPadding) {
  return width - handleWidth - trackPadding * 2;
};
var SwitchHandle = function SwitchHandle(_ref) {
  var translate = _ref.position,
    width = _ref.width;
  return React.createElement(View, {
    style: {
      background: 'white',
      borderRadius: 15,
      width: width,
      height: width,
      translate: translate,
      transition: 'translate 0.3s ease'
    }
  });
};
var SwitchTrack = function SwitchTrack(_ref2) {
  var toggle = _ref2.toggle,
    width = _ref2.width,
    height = _ref2.height,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? SWITCH_TRACK_COLOR : _ref2$color,
    children = _ref2.children,
    sliderWidth = _ref2.sliderWidth,
    sliderColor = _ref2.sliderColor;
  return React.createElement(View, {
    style: {
      background: color,
      borderRadius: 17,
      height: height,
      width: width
    },
    onClick: toggle
  }, React.createElement(SwitchTrackSlider, {
    width: sliderWidth,
    color: sliderColor,
    height: height
  }, children));
};
var SwitchTrackSlider = function SwitchTrackSlider(_ref3) {
  var width = _ref3.width,
    color = _ref3.color,
    children = _ref3.children,
    height = _ref3.height;
  return React.createElement(View, {
    style: {
      background: color,
      borderRadius: 20,
      height: height,
      width: width,
      padding: TRACK_PADDING,
      transition: 'width 0.3s ease, background 0.3s ease'
    }
  }, children);
};
var Switch = function Switch(_ref4) {
  var toggle = _ref4.toggle,
    enabled = _ref4.enabled,
    _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? 'black' : _ref4$color,
    _ref4$width = _ref4.width,
    width = _ref4$width === void 0 ? 70 : _ref4$width,
    _ref4$height = _ref4.height,
    height = _ref4$height === void 0 ? 35 : _ref4$height,
    _ref4$trackPadding = _ref4.trackPadding,
    trackPadding = _ref4$trackPadding === void 0 ? 4 : _ref4$trackPadding,
    _ref4$trackColor = _ref4.trackColor,
    trackColor = _ref4$trackColor === void 0 ? '#EDEDED' : _ref4$trackColor;
  var HANDEL_WIDTH = height - 2 * trackPadding;
  var STEP_WIDTH = calcSwitchPosition(width, HANDEL_WIDTH, trackPadding);
  return React.createElement(SwitchTrack, {
    toggle: toggle,
    width: width,
    height: height,
    sliderWidth: enabled ? width : STEP_WIDTH,
    sliderColor: enabled ? color : trackColor,
    color: trackColor
  }, React.createElement(SwitchHandle, {
    width: HANDEL_WIDTH,
    position: enabled ? STEP_WIDTH : 0
  }));
};

var _excluded$8 = ["children", "style", "noPadding"];
var Card = function Card(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return React.createElement(View, Object.assign({
    style: _extends({
      borderRadius: 15,
      padding: noPadding === true ? 0 : 15,
      overflow: 'hidden',
      border: '1px solid #E7EBF0',
      boxShadow: 'rgba(114, 114, 119, 0.6) 0px 21px 28px -36px',
      backgroundColor: 'white'
    }, style)
  }, rest), children);
};

var _excluded$9 = ["children", "style"];
var SubHeading = function SubHeading(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  return React.createElement("h3", Object.assign({
    style: _extends({
      fontSize: 16,
      padding: '15px 15px 0px 15px',
      marginBottom: 5
    }, style)
  }, rest), children);
};

var HR = function HR(_ref) {
  var _ref$opacity = _ref.opacity,
    opacity = _ref$opacity === void 0 ? 0.5 : _ref$opacity,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '85%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 1.5 : _ref$height;
  return React.createElement(View, {
    style: {
      opacity: opacity,
      width: width,
      height: height,
      border: 'none',
      backgroundColor: '#d8d8d8',
      margin: 0
    }
  });
};

var Button = function Button(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 600 : _ref$weight,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'black' : _ref$color,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$disabledClick = _ref.disabledClick,
    disabledClick = _ref$disabledClick === void 0 ? function () {} : _ref$disabledClick,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$textStyle = _ref.textStyle,
    textStyle = _ref$textStyle === void 0 ? {} : _ref$textStyle,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 1 : _ref$borderWidth;
  var paddingInline = small ? 15 : 20;
  var paddingBlock = small ? 7 : 11;
  if (open) {
    paddingInline = paddingInline - borderWidth * 2;
    paddingBlock = paddingBlock - borderWidth * 2;
  }
  var textColor = color === 'black' ? 'white' : 'black';
  if (open) textColor = 'black';
  return React.createElement(View, {
    motion: true,
    onClick: disabled ? disabledClick : onClick,
    whileTap: {
      scale: disabled ? 1 : 0.95
    },
    center: true,
    style: _extends({
      backgroundColor: color,
      borderRadius: 12,
      paddingInline: paddingInline,
      paddingBlock: paddingBlock,
      cursor: 'pointer',
      opacity: disabled ? 0.4 : 1
    }, open && {
      borderWidth: borderWidth,
      borderStyle: 'solid',
      borderColor: color,
      backgroundColor: 'transparent'
    }, style)
  }, typeof children === 'string' && React.createElement(Text, {
    center: true,
    size: small ? 15 : size,
    weight: small ? 500 : weight,
    color: textColor,
    style: textStyle
  }, children), typeof children !== 'string' && children);
};

var BackdropDismisser = function BackdropDismisser(_ref) {
  var close = _ref.close,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$opacity = _ref.opacity,
    opacity = _ref$opacity === void 0 ? 0.77 : _ref$opacity;
  return React.createElement(View, {
    onClick: close,
    style: _extends({
      position: 'absolute',
      background: "rgba(0,0,0," + opacity + ")",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }, style)
  });
};

var ModalCard = function ModalCard(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$footerStyle = _ref.footerStyle,
    footerStyle = _ref$footerStyle === void 0 ? {} : _ref$footerStyle,
    _ref$contentStyle = _ref.contentStyle,
    contentStyle = _ref$contentStyle === void 0 ? {} : _ref$contentStyle,
    _ref$footer = _ref.footer,
    footer = _ref$footer === void 0 ? null : _ref$footer;
  return React.createElement(View, {
    style: _extends({
      background: 'white',
      padding: 40,
      borderRadius: 20,
      width: '100%',
      maxWidth: 600,
      zIndex: 1,
      maxHeight: '80vh',
      overflow: 'hidden',
      position: 'relative',
      paddingBottom: !!footer ? 100 : 40
    }, style)
  }, React.createElement(View, {
    style: _extends({
      overflow: 'scroll'
    }, contentStyle)
  }, children), !!footer && React.createElement(View, {
    center: true,
    style: _extends({
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'white',
      zIndex: 2,
      padding: 15,
      borderTop: '1px solid rgba(0,0,0,0.05)',
      height: 100
    }, footerStyle)
  }, footer));
};

var _excluded$a = ["children", "style"];
var AbsoluteView = function AbsoluteView(_ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  return React.createElement(View, Object.assign({
    center: true,
    style: _extends({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }, style)
  }, rest), children);
};

var sectionStyle = {
  background: '#fff',
  boxShadow: '0px 8px 5px -8px rgba(0, 0, 0, 0.08)',
  border: '1px solid rgb(243 243 243)',
  fontSize: 16,
  minHeight: 40,
  verticalAlign: 'middle',
  overflow: 'auto',
  marginTop: 0,
  borderRadius: 6
};

export { AbsoluteView, AnimatedTextAreaInput, AnimatedTextInput, B, Back, BackdropDismisser, Body, Breadcrumbs, Button, Card, CloseButton, Container, Dot, Error, FormContainer, Free, GreenButton, HANDEL_WIDTH, HR, I, Loading, LoadingAnimation, LoadingAnimationCutlery, Modal, ModalCard, NumericCodeInput, PageContent, SWITCH_TRACK_COLOR, ScrollView, Spacer, SubHeading, Subtitle, Switch, SwitchHandle, SwitchTrack, TRACK_PADDING, Text, Title, View, Warning, WhiteButton, calcSwitchPosition, sectionStyle };
//# sourceMappingURL=elements.esm.js.map
